import { Button } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { APP_VERSION } from '../configs/version'

// const CHECK_INTERVAL = 5 * 60 * 1000
const CHECK_INTERVAL = 2 * 60 * 1000

const normalizeVersion = (version) => String(version || '').replace(/^v/i, '')

const VersionChecker = () => {
  const [newVersion, setNewVersion] = useState('')

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store'
        })

        if (!response.ok) return

        const data = await response.json()
        const serverVersion = data?.version
        const currentVersion = normalizeVersion(APP_VERSION)
        const nextVersion = normalizeVersion(serverVersion)

        if (!nextVersion || nextVersion === currentVersion) {
          return
        }

        setNewVersion(nextVersion)
      } catch (error) {
        // Ignore version check errors so the app never interrupts users.
      }
    }

    checkVersion()
    const intervalId = window.setInterval(checkVersion, CHECK_INTERVAL)
    window.addEventListener('focus', checkVersion)
    document.addEventListener('visibilitychange', checkVersion)

    return () => {
      window.clearInterval(intervalId)
      window.removeEventListener('focus', checkVersion)
      document.removeEventListener('visibilitychange', checkVersion)
    }
  }, [])

  if (!newVersion) return null

  return (
    <div className="app-version-update-banner">
      <div className="app-version-update-content">
        <strong>Đã có bản cập nhật mới</strong>
        <span>Tải lại trang để sử dụng phiên bản mới nhất.</span>
      </div>
      <Button
        type="primary"
        size="small"
        icon={<ReloadOutlined />}
        onClick={() => window.location.reload()}
      >
        Tải lại
      </Button>
    </div>
  )
}

export default VersionChecker
